import { PaymentRejectType } from '../enum/payment-reject-type.enum';

export const paymentRejectTypeConstant: { [key in PaymentRejectType]: string } = {
  [PaymentRejectType.INVALID_BANK_DETAILS]: 'Неверные банковские реквизиты',
  [PaymentRejectType.SUSPICIOUS_ACTIVITY]: 'Подозрительная активность',
  [PaymentRejectType.OTHER]: 'Другое',
};
